// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__zUIPT","row":"ProcedureTreatmentSummary_row__2UeCy"};